import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import { connect } from "react-redux";
import queryString from "query-string";
import { CircularProgress, IconButton } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SwAlert from "../../components/SwAlert";
import CustomInput from "../../components/CustomInput";
import { resetPassword } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import { createFormikValidation } from "../../utils/Utils";

function AlterarSenha(props) {
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const onSubmit = (values) => {
        const { token, email } = queryString.parse(props.location.search, { decode: false });
        setLoading(true);

        resetPassword({ ...values, token, email })
            .then(() => {
                SwAlert({
                    title: `Senha redefinida com sucesso.`,
                    confirmButtonText: "Fechar",
                    icon: "success",
                    customClass: {
                        content: "p-0 pb-32",
                    },
                    timer: 3000,
                });

                history.push("/");
            })
            .catch((err) => {
                SwAlert({
                    title: err?.response?.data?.errors?.[0] ?? `Parece que houve um problema`,
                    text: err?.response?.data?.errors ? null : "Por favor, entre em contato com o suporte.",
                    customClass: {
                        content: err?.response?.data?.errors ? "p-0 pb-32" : "",
                    },
                    confirmButtonText: "Fechar",
                    icon: "error",
                });
            })
            .finally(() => setLoading(false));
    };

    const getInitialValues = () => {
        return {
            pin: "",
        };
    };

    const validate = (values) => {
        const map = new Map();
        const errors = {};

        map.set("password", "senha");
        map.set("password_confirmation", "confirmar senha");

        if (values.password !== values.password_confirmation) {
            errors.password = "As senhas não conferem.";
            errors.password_confirmation = "As senhas não conferem.";
        }

        return { ...errors, ...createFormikValidation(map, values) };
    };

    return (
        <div class="authContainerContainer senha">
            <div className="esqueceuSenhaContainer">
                <div>
                    <IconButton onClick={() => history.push("/login")} className="p-0">
                        <div className="d-flex gap-8 align-items-center color-dark-6">
                            <ArrowBackIosIcon style={{ color: "#9CA3AF", fontSize: 14 }} />

                            <span className={`tt-16 medium`}>Voltar</span>
                        </div>
                    </IconButton>
                </div>

                <div className="d-flex flex-column gap-12">
                    <span className={`tt-24 semibold color-white`}>Altere sua senha</span>

                    <span className={`tt-16 color-dark-6`}>Escolha sua nova senha </span>
                </div>

                <Formik initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                    {({ handleBlur, handleChange, errors, touched, handleSubmit }) => (
                        <form noValidate autoComplete="off" onSubmit={handleSubmit} className="d-flex flex-column gap-40">
                            <div className="d-flex flex-column gap-32">
                                <CustomInput placeholder="Insira uma nova senha" label="Nova senha" name="password" handleBlur={handleBlur} handleChange={handleChange} errors={errors} touched={touched} disabled={loading} />

                                <CustomInput placeholder="Repita a senha criada para confirmar" label="Confirmar senha" name="password_confirmation" handleBlur={handleBlur} handleChange={handleChange} errors={errors} touched={touched} disabled={loading} />
                            </div>

                            <button type="submit" disabled={loading} className="btn btn-primary btn-large tt-16 medium">
                                {loading ? <CircularProgress size={14} className="margin-icon" style={{ color: "#fff" }} /> : null}Alterar senha
                            </button>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
}

export default connect(null, auth.actions)(AlterarSenha);
